import { MessageSeverity } from "../../../assets/utils/lib/messageSeverity";
import { createInstance } from "./responseUtility";

export interface IResultMessage {
    message?: string | null;
    severityType?: MessageSeverity;
    severity?: string | null;
}

export class ResultMessage implements IResultMessage {
    message?: string | null;
    severityType?: MessageSeverity;
    readonly severity?: string | null;

    constructor(data?: IResultMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.severityType = _data["severityType"] !== undefined ? _data["severityType"] : null as any;
            (this as any).severity = _data["severity"] !== undefined ? _data["severity"] : null as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ResultMessage | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ResultMessage>(data, _mappings, ResultMessage);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["severityType"] = this.severityType !== undefined ? this.severityType : null as any;
        data["severity"] = this.severity !== undefined ? this.severity : null as any;
        return data;
    }

    clone(): ResultMessage {
        const json = this.toJSON();
        let result = new ResultMessage();
        result.init(json);
        return result;
    }
}